import component from './family-plan-member.component';
import routes from './family-plan-member.routes';
import familyPlanMemberRegistrationDialogComponent from './../family-plan-member-registration-dialog/family-plan-member-registration-dialog.component';
import familyPlanMemberStartListenDialogComponent from './../family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.component';
import familyPlanMemberSameAddressAlertDialogComponent from './../family-plan-member-same-address-alert-dialog/family-plan-member-same-address-alert-dialog.component';




export default angular
  .module('fizyweb.paycell.familyplanmember', [])
  .component('fizyPaycellFamilyPlanMember', component)
  .component('familyPlanMemberRegistrationDialog', familyPlanMemberRegistrationDialogComponent)
  .component('familyPlanMemberStartListenDialog', familyPlanMemberStartListenDialogComponent)
  .component('familyPlanMemberSameAddressAlertDialog', familyPlanMemberSameAddressAlertDialogComponent)
  .config(routes).name;


  



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member/family-plan-member.module.ts